import app from 'flarum/forum/app';
import m from 'mithril';
import Link from 'flarum/common/components/Link';
import icon from 'flarum/common/helpers/icon';
import DiscussionComposer from 'flarum/forum/components/DiscussionComposer';
import LogInModal from 'flarum/forum/components/LogInModal';

/**
 * App-like bottom navigation bar (phones only).
 * A plain Mithril component mounted once, outside the router.
 */
export default {
  view() {
    // Mounted during boot, before app.session / the router exist — guard.
    if (!app.session || !app.forum) return null;

    const user = app.session.user;
    const path = (m.route.get() || '/').split('?')[0];
    const isActive = (test) => (test(path) ? ' active' : '');

    const startDiscussion = (e) => {
      e.preventDefault();
      if (user) {
        app.composer.load(DiscussionComposer, { user });
        app.composer.show();
      } else {
        app.modal.show(LogInModal);
      }
    };

    const focusSearch = (e) => {
      e.preventDefault();
      // The search field lives in the drawer on phones: open it, then focus.
      if (app.drawer) app.drawer.show();
      setTimeout(() => {
        const input = document.querySelector('.Search-input input');
        if (input) input.focus();
      }, 60);
    };

    const item = (attrs, iconName, label, extra) => (
      <Link {...attrs} className={'RvsrBottomNav-item' + (attrs.className || '')}>
        <span className="RvsrBottomNav-iconWrap">
          {icon(iconName, { className: 'RvsrBottomNav-icon' })}
          {extra}
        </span>
        <span className="RvsrBottomNav-label">{label}</span>
      </Link>
    );

    const unread = user ? user.newNotificationCount() : 0;

    return (
      <nav className="RvsrBottomNav" aria-label="Navigasi utama">
        {item({ href: app.route('index'), className: isActive((p) => p === '/' || p.startsWith('/all')) }, 'fas fa-home', 'Home')}
        {item(
          { href: app.route('tags'), className: isActive((p) => p.startsWith('/tags') || p.startsWith('/t/')) },
          'fas fa-layer-group',
          'Tag'
        )}

        <a className="RvsrBottomNav-item RvsrBottomNav-new" href="#" onclick={startDiscussion} aria-label="Diskusi baru">
          {icon('fas fa-plus', { className: 'RvsrBottomNav-icon' })}
        </a>

        {user
          ? item(
              { href: app.route('notifications'), className: isActive((p) => p.startsWith('/notifications')) },
              'fas fa-bell',
              'Notif',
              unread ? <span className="RvsrBottomNav-badge">{unread > 99 ? '99+' : unread}</span> : null
            )
          : (
              <a className="RvsrBottomNav-item" href="#" onclick={focusSearch}>
                <span className="RvsrBottomNav-iconWrap">{icon('fas fa-search', { className: 'RvsrBottomNav-icon' })}</span>
                <span className="RvsrBottomNav-label">Cari</span>
              </a>
            )}

        {user ? (
          item({ href: app.route.user(user), className: isActive((p) => p.startsWith('/u/')) }, 'fas fa-user', 'Akun')
        ) : (
          <a
            className="RvsrBottomNav-item"
            href="#"
            onclick={(e) => {
              e.preventDefault();
              app.modal.show(LogInModal);
            }}
          >
            <span className="RvsrBottomNav-iconWrap">{icon('fas fa-sign-in-alt', { className: 'RvsrBottomNav-icon' })}</span>
            <span className="RvsrBottomNav-label">Masuk</span>
          </a>
        )}
      </nav>
    );
  },
};
